export default __webpack_public_path__ + "assets/be514b7c0c389c4421e6da4e1130abc0.png";